import esMessages from "../bbui/i18n/es";
export default esMessages;
